import React from 'react';
import CapacityPlantTemplate from '../../components/CapacityPlantTemplate';
import { capacityPlants } from '../../data/capacityPlants';

const WaterPlant200BPM = () => (
  <CapacityPlantTemplate plant={capacityPlants['/200-bpm-water-plant']} path="/200-bpm-water-plant" />
);

export default WaterPlant200BPM;
